export function ValueProposition() {
  return (
    <section className="py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-4xl mx-auto space-y-4">
          <h2 className="text-3xl lg:text-5xl font-bold text-balance">
            Con Rapyfact, la solución más <span className="text-primary">Intuitiva</span> y{" "}
            <span className="text-primary">Eficiente</span> en Colombia
          </h2>
        </div>
      </div>
    </section>
  )
}
